import {
  BasicButton,
  ButtonGroup,
  Grid,
  GridItem,
  LegacyModal,
  Link,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  TextInputField,
} from "@certn/cascadia-react";
import { Field, Form, Formik } from "formik";
import i18next from "i18next";
import { Trans, useTranslation } from "react-i18next";

import { CountrySelect } from "../../../../components/AddressInput";

type Institution = {
  college_name: string;
  college_country: string;
};

type InstitutionInputModalProps = {
  value: Institution;
  onChange: (value: Institution) => void;
};

export function InstitutionInputModal({
  value,
  onChange,
}: InstitutionInputModalProps) {
  const { t } = useTranslation();

  const isEdit = !!value.college_name;

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          linkStyle="monochrome"
          textStyle="global/body-secondary"
          testID={
            isEdit
              ? "social-media-details-post-secondary-institution-edit-button"
              : "social-media-details-post-secondary-institution-add-button"
          }
        >
          {isEdit ? t("Edit") : t("Add")}
        </Link>
      )}
    >
      {(close) => (
        <Formik
          initialValues={{
            college_name: value.college_name,
            college_country:
              value.college_country || i18next.language.split("-")[1],
          }}
          onSubmit={(institution: Institution) => {
            onChange(institution);
            close();
          }}
        >
          {({ handleSubmit }) => (
            <LegacyModal width="456px">
              <ModalHeader
                close={close}
                title={
                  isEdit
                    ? t("Edit post secondary details")
                    : t("Add post secondary details")
                }
                testID="social-media-details-modal"
              />

              <ModalContent>
                <Form>
                  <Grid>
                    <GridItem>
                      <CountrySelect
                        name="college_country"
                        label={t("Country")}
                        isRequired
                        testID="social-media-details-modal-country-select"
                      />
                    </GridItem>

                    <GridItem>
                      <Field
                        label={t("Institution name")}
                        name="college_name"
                        isRequired
                        as={TextInputField}
                        testID="social-media-details-modal-institution-name-input"
                      />
                    </GridItem>
                  </Grid>
                </Form>
              </ModalContent>

              <ModalFooter>
                <ButtonGroup>
                  <BasicButton
                    size="medium"
                    onPress={close}
                    testID="social-media-details-modal-cancel-button"
                  >
                    <Trans>Cancel</Trans>
                  </BasicButton>
                  <PrimaryButton
                    type="submit"
                    size="medium"
                    onPress={() => handleSubmit()}
                    testID="social-media-details-modal-save-button"
                  >
                    {isEdit ? t("Save") : t("Add")}
                  </PrimaryButton>
                </ButtonGroup>
              </ModalFooter>
            </LegacyModal>
          )}
        </Formik>
      )}
    </ModalTrigger>
  );
}
